import React from "react";
import { makeStyles } from "@mui/styles";
import { CssBaseline } from "@mui/material";
import clsx from "clsx";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Toolbar,
  Container,
  List,
  ListItem,
  ListItemIcon,
  IconButton,
  Typography,
  Drawer,
  ListItemText,
  Avatar,
  Divider,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import { ListItemButton } from "@mui/material";
import {
  AccountCircle,
  Logout,
  Groups,
  Work,
  CompareArrows,
  Source,
  CalendarMonth,
  AccountTree,
  People,
  Quiz,
  Home,
} from "@mui/icons-material";

import Groups3Icon from "@mui/icons-material/Groups3";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import SidebarBkg from "../../src/images/sidebar-bg.jpg";
import { logout } from "../actions/auth.js";
import ConditionalRenderer from "./ConditionalRenderer.jsx";
const drawerWidth = 190;
const useStyles = makeStyles((theme) => ({
  root: {
    "&&": {
      display: "flex",
      height: "100vh",
      overflow: "auto",
      color: "#000133",
    },
  },
  toolbar: {
    "&&": {
      paddingRight: 24, // keep right padding when drawer closed
      minHeight: "50px",
    },
  },
  icon: {
    "&&": {
      padding: "10px",
    },
  },
  toolbarIcon: {
    "&&": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 8px",
      position: "relative",
      ...theme.mixins.toolbar,
      minHeight: "50px !important",
    },
  },
  appBar: {
    "&&": {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      background: "#FFF !important",
      // backgroundColor: "#0e1832",
      color: "#101728",
      boxShadow: "0px 0px 8px #e1e1e1",
    },
  },
  appBarShift: {
    "&&": {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },
  menuButton: {
    "&&": {
      marginRight: 36,
      "&:hover": {
        backgroundColor: "#005480",
        color: "#fff",
        borderRadius: "4px",
      },
    },
  },
  button: {
    "&&": {
      "&:hover": {
        backgroundColor: "#B9D9EB",
        color: "black",
        borderRadius: "0px",
        borderRight: "5px solid #1976d2",
      },
      padding: "8px",
      borderRadius: "0px",
      justifyContent: "flex-start ",
    },
  },
  IconColor: {
    "&&": {
      "&:hover": {
        color: "black",
      },
    },
  },
  listitemtext: {
    "&&": {
      "&:active": {
        fontWeight: "700",
      },
    },
  },
  menuButtonHidden: {
    "&&": {
      display: "none",
    },
  },
  title: {
    "&&": {
      // marginRight: "auto",
      flexGrow: 1,
      fontSize: "18px",
      color: "#fff",
      fontWeight: 700,
      fontFamily: "Roboto",
    },
  },
  drawerPaper: {
    "&&": {
      color: "#fff",
      //background: `url(${SidebarBkg}), #005480`,
      backgroundColor: "#005480",
      transition: "width .2s",
      border: "none",
      backgroundSize: "cover",
      position: "relative",
      whiteSpace: "nowrap",
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },
  drawerPaperClose: {
    "&&": {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(8),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(5.0),
      },
      "@media (max-width: 520px)": {
        width: theme.spacing(5),
        [theme.breakpoints.up("sm")]: {
          width: theme.spacing(4.2),
        },
      },
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  appBarSpacer: {
    "&&": {
      minHeight: "50px",
    },
  },
  content: {
    "&&": {
      // content which is class of main needs to be flex and column direction
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      height: "100vh",
      overflow: "auto",
      background: "#f0f2f5",
    },
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    flex: 1,
    background: "#f0f2f5",
    color: "black",
  },
  paper: {
    "&&": {
      padding: theme.spacing(2),
      display: "flex",
      overflow: "auto",
      flexDirection: "column",
    },
  },
  fixedHeight: {
    "&&": {
      height: 240,
    },
  },
  // added the footer class
  footer: {
    "&&": {
      padding: theme.spacing(2),
      marginTop: "auto",
      alignSelf: "flex-end",
      background: "#00022E",
      height: "50px",
      color: "#FC86AA",
    },
  },

  listItem: {
    "&&": {
      padding: 0,
    },
  },

  listText: {
    "&&": {
      overflow: "hidden",
      background: "#fff",
    },
  },
  main: {
    "&&": {
      flex: 1,
      background: "#f7f5f5",
      color: "black",
    },
  },
  avatarButton: {
    "&&": {
      marginLeft: "auto !important",
    },
  },
}));

// const useStyles = makeStyles(styles);

export default function Layout({ children }) {
  const { data: user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const classes = useStyles();
  const { pathname } = useLocation();

  const [drawerOpen, setDrawerOpen] = useState(true);
  const toggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="absolute"
        className={clsx(
          classes.appBar,
          drawerOpen && classes.appBarShift,
          drawerOpen && classes.appBarShift
        )}
      >
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={toggleDrawer}
            className={clsx(classes.menuButton)}
          >
            <MenuIcon />
          </IconButton>
          {/* ------Logout Button------ */}
          <Tooltip title="Account settings" className={classes.avatarButton}>
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <Avatar sx={{ width: 40, height: 40 }} />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {/* <MenuItem
              containerElement={<Link to="/profile" />}
              onClick={handleClose}
            >
              <Avatar /> Profile
            </MenuItem> */}
            {/* <Divider /> */}
            <MenuItem
              onClick={() => {
                dispatch(logout());
              }}
            >
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        classes={{
          paper: clsx(
            classes.drawerPaper,
            !drawerOpen && classes.drawerPaperClose,
            !drawerOpen && classes.drawerPaperClose
          ),
        }}
        open={drawerOpen}
        close={!drawerOpen}
      >
        <div className={classes.toolbarIcon}>
          {/* <Typography variant="h6" className={classes.title}>
            Project Management
          </Typography> */}
          <center>
            <Typography
              variant="h6"
              className={classes.title}
              component="div"
              sx={{ flexGrow: 1 }}
            >
              ODR
            </Typography>
          </center>
        </div>
        <Divider />
        <List>
          <>
            <CustomCheck type={user.role}></CustomCheck>
          </>
        </List>
      </Drawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        {/* <Container maxWidth="lg" className={classes.container}> */}
        <Container className={classes.container}>{children}</Container>
      </main>

      {/* <Box component="main" p={4} className={classes.main}>
          {children}
        </Box> */}
    </div>
  );
}

function CustomListItem({ icon, text, to, active = false }) {
  const classes = useStyles();

  return (
    <Link to={to} className="hyperlink">
      <ListItem className={classes.listItem}>
        <ListItemButton
          className={classes.button}
          sx={{
            pr: 1,
            pl: 1,
            // backgroundColor: active ? "#6f5847" : "inherit",
            backgroundImage: active
              ? "linear-gradient( 95.2deg, #ffffff 26.8%, #e3eaf1 64% )"
              : "inherit",
            color: active ? "black" : "inherit",
            borderRadius: "0px",
            borderRight: active ? "5px solid #1976d2" : "inherit",
          }}
        >
          <ListItemIcon
            className={classes.sidebaricon}
            sx={{
              minWidth: "35px",
              color: active ? "#1976d2" : "inherit",
            }}
          >
            {icon}
          </ListItemIcon>
          <ListItemText
            sx={{ fontWeight: active ? "700 !important" : "inherit" }}
            primary={text}
          />
        </ListItemButton>
      </ListItem>
    </Link>
  );
}

function CustomCheck({ type }) {
  const classes = useStyles();
  const { pathname } = useLocation();
  const { data: user } = useSelector((state) => state.user);
  return (
    <>
      <ConditionalRenderer
        show={/^admin|registrar|trial_user$/i.test(user.roles)}
      >
        <CustomListItem
          icon={<Home className={classes.IconColor} />}
          text="Dasboard"
          to="/dashboard"
          active={pathname === "/dashboard"}
        />
      </ConditionalRenderer>

      <CustomListItem
        icon={<AccountCircle className={classes.IconColor} />}
        text="Profile"
        to="/profile"
        active={pathname === "/profile"}
      />
      <ConditionalRenderer show={/^admin|registrar$/i.test(user.roles)}>
        <CustomListItem
          icon={<People className={classes.IconColor} />}
          text="Users"
          to="/users"
          active={pathname === "/users"}
        />
      </ConditionalRenderer>
      {/* <CustomListItem
        icon={<Groups className={classes.IconColor} />}
        text="Meetings"
        to="/meetings"
        active={pathname === "/meetings"}
      /> */}
      <CustomListItem
        icon={<Work className={classes.IconColor} />}
        text="Cases"
        to="/cases"
        active={pathname === "/cases"}
      />
      <ConditionalRenderer
        show={/^admin|registrar|trial_user$/i.test(user.roles)}
      >
        <CustomListItem
          icon={<Quiz className={classes.IconColor} />}
          text="Survey Questions"
          to="/questions"
          active={pathname === "/questions"}
        />
      </ConditionalRenderer>
      <ConditionalRenderer
        show={/^admin|registrar|trial_user$/i.test(user.roles)}
      >
        <CustomListItem
          icon={<Quiz className={classes.IconColor} />}
          text="Submitted Q/A"
          to="/submittedques"
          active={pathname === "/submittedques"}
        />
      </ConditionalRenderer>

      <CustomListItem
        icon={<Source className={classes.IconColor} />}
        text="Documents"
        to="/documents"
        active={pathname === "/documents"}
      />
      <CustomListItem
        icon={<CalendarMonth className={classes.IconColor} />}
        text="Calendar"
        to="/calendar"
        active={pathname === "/calendar"}
      />
      <CustomListItem
        icon={<CompareArrows className={classes.IconColor} />}
        text="Negotiations"
        to="/negotiation"
        active={pathname === "/negotiation"}
      />
      {/* <CustomListItem
        icon={<AccountTree className={classes.IconColor} />}
        text="Dispute Items"
        to="/dispute-items"
        active={pathname === "/dispute-items"}
      /> */}
      <ConditionalRenderer show={/^admin$/i.test(user.roles)}>
        <CustomListItem
          icon={<Groups3Icon className={classes.IconColor} />}
          text="Customers"
          to="/customer"
          active={pathname === "/customer"}
        />
      </ConditionalRenderer>
    </>
  );
}
